/**
 * Default messages of the business Rules. Own keys, not the legacy `VALIDATION.*` ones, so those go with vee-validate.
 * A top-level key of its own: `src/locale/i18n.messages.ts` merges only top-level keys, so a second `FORMS` would replace the module's.
 */
export const TRANSLATIONS = {
    EN: {
        FORMS_BUSINESS: {
            KVK_NUMBER: 'Enter a KVK number of 8 digits',
            KVK_COMPANY: 'Select a company from the search results',
            IBAN: 'Enter a valid IBAN',
            DUTCH_VAT_NUMBER: 'Enter a VAT number like NL123456789B01',
            DUTCH_POSTCODE: 'Enter a postcode like 1234 AB',
            PHONE_NUMBER: 'Enter a valid phone number',
            URL: 'Enter a valid web address',
            CURRENCY_AMOUNT: 'Enter an amount with at most 2 decimals',
            NO_BV_IN_NAME: 'Leave out "BV": it is added to the company name automatically',
            AGE_BETWEEN: 'You must be between {min} and {max} years old',
            LOW_RISK_COUNTRY: 'Unfortunately, this country is not possible',
            EMAIL_DOMAIN: 'This email address cannot receive mail',
        },
    },
    NL: {
        FORMS_BUSINESS: {
            KVK_NUMBER: 'Vul een KVK-nummer van 8 cijfers in',
            KVK_COMPANY: 'Selecteer een bedrijf uit de zoekresultaten',
            IBAN: 'Vul een geldig IBAN in',
            DUTCH_VAT_NUMBER: 'Vul een btw-nummer in zoals NL123456789B01',
            DUTCH_POSTCODE: 'Vul een postcode in zoals 1234 AB',
            PHONE_NUMBER: 'Vul een geldig telefoonnummer in',
            URL: 'Vul een geldig webadres in',
            CURRENCY_AMOUNT: 'Vul een bedrag in met maximaal 2 decimalen',
            NO_BV_IN_NAME: 'Laat "BV" weg: dat wordt automatisch aan de bedrijfsnaam toegevoegd',
            AGE_BETWEEN: 'Je moet tussen de {min} en {max} jaar oud zijn',
            LOW_RISK_COUNTRY: 'Dit land is helaas niet mogelijk',
            EMAIL_DOMAIN: 'Dit e-mailadres kan geen e-mail ontvangen',
        },
    },
};
